import type {
  HubCameraExampleStreamConfig,
} from '@robovision/hub'
import {
  Camera,
  type CameraParams,
} from './Camera'
import { ConfiguredCameraData } from './ConfiguredCameraData'


interface ConfiguredCameraParams extends CameraParams {
  configFile?: File
  configName: string
  configStatus: string
  configStatusMessage?: string
  viewName: string
  viewPath: string
}

export class ConfiguredCamera extends Camera {
  public configFile?: File
  public configName: string
  public configStatus: string
  public configStatusMessage?: string
  public viewName: string
  public viewPath: string

  constructor (params: ConfiguredCameraParams) {
    super(params)
    this.configFile = params.configFile
    this.configName = params.configName
    this.configStatus = params.configStatus
    this.configStatusMessage = params.configStatusMessage
    this.viewName = params.viewName
    this.viewPath = params.viewPath
  }

  public static fromResponse (data: HubCameraExampleStreamConfig): ConfiguredCamera {
    const baseCamera = Camera.fromHubCameraExampleStreamConfig(data)

    return new ConfiguredCamera({
      cameraType: baseCamera.cameraType,
      configFile: undefined,
      configName: data.configName,
      configStatus: data.configStatus,
      configStatusMessage: data.configStatusMessage,
      createdAt: baseCamera.createdAt,
      id: baseCamera.id,
      name: baseCamera.name,
      serialNumber: baseCamera.serialNumber,
      status: baseCamera.status,
      thumbnail: baseCamera.thumbnail,
      viewName: data.viewName,
      viewPath: data.viewPath,
    })
  }

  public toData (): ConfiguredCameraData {
    return new ConfiguredCameraData({
      camera: this,
      configFile: this.configFile ?? new File([], ''),
      configName: this.configName,
      thumbnail: this.thumbnail,
      viewName: this.viewName,
      viewPath: this.viewPath,
    })
  }
}
